import React from "react";
import marketingPreviewImg from "../../assets/marketing.webp";
import utilityPreviewImg from "../../assets/utility.webp";
import authenticationPreviewImg from "../../assets/authentication.webp";
import { TC_RADIUS } from "../../constants/templateCreatorConstants";

const CATEGORY_IMAGES = {
  MARKETING: marketingPreviewImg,
  UTILITY: utilityPreviewImg,
  AUTHENTICATION: authenticationPreviewImg,
};

const SetupTemplatePreview = ({ category, preview }) => {
  const imageSrc = CATEGORY_IMAGES[category] || marketingPreviewImg;

  return (
    <div className={`border border-[#ccd0d5] ${TC_RADIUS} bg-white overflow-hidden`}>
      <div className="px-4 py-3 border-b border-[#dddfe2]">
        <h3 className="text-[15px] font-semibold text-[#050505]">
          Template preview
        </h3>
      </div>

      <div className="p-3">
        <img
          src={imageSrc}
          alt="Template message preview"
          className="w-full h-auto block"
        />

        <div className="mt-3 space-y-2">
          <p className="text-[13px] text-[#050505] leading-relaxed">
            <span className="font-semibold">This template is good for:</span>{" "}
            <span className="text-[#65676b]">{preview.goodFor}</span>
          </p>
          <p className="text-[13px] text-[#050505] leading-relaxed">
            <span className="font-semibold">
              Template areas that you can customise:
            </span>{" "}
            <span className="text-[#65676b]">{preview.areas}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SetupTemplatePreview;

export const SETUP_CATEGORY_PREVIEWS = {
  MARKETING: {
    goodFor:
      "Welcome messages, promotions, offers, coupons, newsletters, announcements.",
    areas: "Media, header, body, footer, button.",
  },
  UTILITY: {
    goodFor:
      "Order confirmations, account update, receipts, appointment reminders, billing.",
    areas: "Media, header, body, footer, button.",
  },
  AUTHENTICATION: {
    goodFor:
      "One-time password, account recovery code, account verification, integrity challenges.",
    areas: "Code delivery method.",
  },
};
